import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { ContactLensesBundleBeneluxSolutions } from '../../ContactLensesBundleBeneluxSolutions/layouts/ContactLensesBundleBeneluxSolutions.js';
import { UpsellLayout } from '../components/UpsellLayout.js';
import { UpsellCategory } from '../layouts/UpsellCategory.js';
import { UpsellProducts } from '../layouts/UpsellProducts.js';

// FYI: Many of these labels haven't been implemented in Bloomreach yet
const productTypeSpecificMessageLabelMapping = {
    'contact-lenses-bundle-benelux': 'cart.notification.upsell.contactLensesBundleBenelux.message',
    'contact-lenses': 'cart.notification.upsell.contactLenses.message',
    'contact-lenses-subscription': 'cart.notification.upsell.contactLensesSubscription.message',
    'prescription-glasses': 'cart.notification.upsell.prescriptionGlasses.message',
    'non-prescription-bundle': 'cart.notification.upsell.nonRxBundle.message',
    frames: 'cart.notification.upsell.frames.message',
    solutions: 'cart.notification.upsell.solution.message',
    sunglasses: 'cart.notification.upsell.sunglasses.message',
    'ready-readers': 'cart.notification.upsell.readyReaders.message',
    accessories: 'cart.notification.upsell.accessories.message'
};
const ProductTypeMessages = ({ lineItemTypes  })=>{
    const { getLabel  } = useIntl();
    const messages = lineItemTypes.map((t)=>getLabel(productTypeSpecificMessageLabelMapping[t], {
            hideLabelKey: true
        })
    ).filter(Boolean);
    if (messages.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        message: [
            ...messages
        ]
    });
};
const UpsellContainer = ({ lineItems , products , recommendedCategoryKey , subscriptionProductSku ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            upsellCategoryHeading: getLabel('cart.notification.productAdded'),
            clbbCategoryHeading: getLabel('products.contactLenses.solutions.title')
        })
    , [
        getLabel
    ]);
    const lineItemTypes = [
        ...new Set(lineItems.map((l)=>l.type
        ))
    ];
    if (subscriptionProductSku && lineItems.some((lineItem)=>lineItem.type === 'contact-lenses-bundle-benelux'
    )) {
        return /*#__PURE__*/ React.createElement(UpsellLayout, {
            heading: labels.clbbCategoryHeading
        }, /*#__PURE__*/ React.createElement(ProductTypeMessages, {
            lineItemTypes: lineItemTypes
        }), /*#__PURE__*/ React.createElement(ContactLensesBundleBeneluxSolutions, {
            subscriptionProductSku: subscriptionProductSku
        }));
    }
    if (recommendedCategoryKey) {
        return /*#__PURE__*/ React.createElement(UpsellLayout, {
            heading: labels.upsellCategoryHeading
        }, /*#__PURE__*/ React.createElement(ProductTypeMessages, {
            lineItemTypes: lineItemTypes
        }), /*#__PURE__*/ React.createElement(UpsellCategory, {
            recommendedCategoryKey: recommendedCategoryKey
        }));
    }
    if (products) {
        return /*#__PURE__*/ React.createElement(UpsellLayout, {
            heading: labels.upsellCategoryHeading
        }, /*#__PURE__*/ React.createElement(ProductTypeMessages, {
            lineItemTypes: lineItemTypes
        }), /*#__PURE__*/ React.createElement(UpsellProducts, {
            products: products
        }));
    }
    return null;
};

export { UpsellContainer };
//# sourceMappingURL=UpsellContainer.js.map
